module.exports = __webpack_public_path__ + "img/swiper_3.5_3_2.dbb91965.webp";